import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export enum ActionType {
    None = 'NONE',
    Cancel = 'CANCEL',
    Save = 'SAVE',
    StartTransition = 'START_TRANSITION',
    ChangeTicketType = 'CHANGE_TICKET_TYPE',
    UploadAttachedFile = 'UPLOAD_ATTACHMENT',
    FinishedUploadingAttachments = 'FINISHED_UPLOADING_ATTACHMENTS',
    DrugScreenSelected = 'DRUG_SCREEN_SELECTED',
    AttachmentsChanged = 'ATTACHMENTS_CHANGED'
}

export interface ActionInfo {
    action: ActionType;
    data?: any;
}

@Injectable({
    providedIn: 'root'
})
export class ComplianceActionService {
    constructor() {}
    private readonly action$: Subject<ActionInfo> = new Subject();

    getAction(): Observable<ActionInfo> {
        return this.action$.asObservable();
    }

    setAction(action: ActionInfo): void {
        this.action$.next(action);
    }
}
